import { LanguageSelect } from '@repo/videa-notes';

import {
  useRecorderState,
  useTemplateSelection,
} from '../../../context/VideaNotesRecordingContext';

/**
 * Renders language selection in the recording flow header when the practice
 * supports multiple languages. Hidden during recording/pause (recorder not
 * stopped) and after recording completes (mediaBlobUrl set) to match other
 * header controls and avoid mid-session language changes.
 */
export const RecordingFlowHeaderLanguage = () => {
  const { mediaBlobUrl, recorderStatus } = useRecorderState();
  const { supportedLanguages, selectedLanguage, onSelectedLanguage } =
    useTemplateSelection();

  const isRecordingOrPaused =
    recorderStatus === 'recording' || recorderStatus === 'paused';
  if (mediaBlobUrl || isRecordingOrPaused || supportedLanguages.length <= 1) {
    return null;
  }

  return (
    <div className="vai-w-full vai-min-w-0">
      <LanguageSelect
        supportedLanguages={supportedLanguages}
        selectedLanguage={selectedLanguage}
        onSelectedLanguage={onSelectedLanguage}
      />
    </div>
  );
};
